import mojs from '@mojs/core/dist/mo.umd.js';
import BaseAnimation from './BaseAnimation.js';

class MojsAnimation extends BaseAnimation {
	init() {
		let opacity = this.$scope.data('opacity');

		if (opacity && typeof opacity === 'object') {
			let from = Object.keys(opacity)[0];
			if (from !== undefined) {
				this.$scope.css('opacity', from);
			}
		}
	}

	animate() {
		let animation = this.animation || this.createAnimation();

		if (animation) {
			animation.play();
		}
	}

	destroy() {
		this.$scope.css('opacity', '');
	}

	createAnimation() {
		let settings = Object.assign({
			el: this.$scope[0],
			duration: this.config.duration,
			easing: 'ease.out',
			delay: this.config.delay
		}, this.$scope.data());

		delete settings.animate;
		delete settings.animateGroup;
		delete settings.animateType;
		delete settings.animateYOnly;
		delete settings.prio;
		delete settings.groupedDelay;
		delete settings.timeline;

		try {
			this.animation = new mojs.Html(settings);
			return this.animation;
		} catch (error) {
			console.error('Animate: kon animatie niet aanmaken', this.$scope[0], error);
			this.$scope.css('opacity', '');
			return null;
		}
	}
}

export default MojsAnimation;
